import { PageAttr } from "../../../../shared/domain/entities/fetch-entities";
import { pickBy } from "lodash";
import { useConcatPages } from "../../../../shared/infrastructure";
import { useFetch } from "../../../../public/auth/infrastructure/store/fetch-context";
import { CarrierT, UseGetCarriersFilters } from "../../domain";
import {
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  useInfiniteQuery,
} from "@tanstack/react-query";

const carrierKeys = {
  all: ["carriers"] as const,
  carriers: () => [...carrierKeys.all, "carriers-list"] as const,
  carriersList: (filters: UseGetCarriersFilters) =>
    [...carrierKeys.carriers(), filters] as const,
};

const CARRIERS_ENDPOINT = "carriers";

const useInfiniteGetCarriers = (
  filters: UseGetCarriersFilters,
  config: UseInfiniteQueryOptions<PageAttr<CarrierT>> = {}
): UseInfiniteQueryResult<PageAttr<CarrierT>> & {
  allPages: PageAttr<CarrierT>["data"];
} => {
  const fetch = useFetch();

  const response = useInfiniteQuery<PageAttr<CarrierT>>(
    carrierKeys.carriersList(filters),
    async ({ pageParam: page = 1 }: { pageParam?: number }) => {
      const response = await fetch.get<PageAttr<CarrierT>>(CARRIERS_ENDPOINT, {
        params: {
          page,
          limit: 10,
          ...pickBy(filters),
        },
      });

      return response.data;
    },
    {
      ...config,
      getNextPageParam: (lastPage, allPages) =>
        lastPage.data.length > 0 ? allPages.length + 1 : undefined,
    }
  );

  const allPages = useConcatPages(response.data?.pages ?? []);

  return {
    ...response,
    allPages,
  };
};

export { carrierKeys, useInfiniteGetCarriers };
